<template>
  <Avatar
    v-if="isError || !url"
    :label="`${name.at(0)}${surname.at(0)}`"
    :size="size"
    shape="circle"
    class="select-none"
  />
  <Avatar
    v-else
    :image="url"
    :size="size"
    shape="circle"
    @error="isError = true"
  />
</template>

<script setup lang="ts">
import { AvatarProps } from 'primevue'
import { ref } from 'vue'

defineProps<{
  url: string | null
  name: string
  surname: string
  size?: AvatarProps['size']
}>()

const isError = ref(false)
</script>
